import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Tag: the small status tags that say how the assistant knows something (the kit's wp-tag):
// verified ('Verified on screen'), inferred ('Read from the screen'), asked ('You chose') and skipped.
// The wording comes from the caller through t(); a tag is text, not a control.
import { cva } from "class-variance-authority";
import { Glyph } from "./button.js";
import { cn } from "./cn.js";
export const tagVariants = cva([
    "inline-flex shrink-0 items-center whitespace-nowrap rounded-pill border border-transparent",
    "font-sans text-11 font-semibold leading-none",
], {
    variants: {
        variant: {
            verified: "bg-wp-accent/13 text-wp-accent",
            inferred: "border-wp-accent/44 text-wp-accent",
            asked: "bg-br-sky/9 text-wp-text-2",
            skipped: "border-dashed border-wp-line-strong text-wp-text-3",
        },
        compact: {
            false: "h-5 gap-1 pl-1 pr-2",
            true: "h-4.5 gap-0.5 pl-1 pr-1.5",
        },
    },
    defaultVariants: { variant: "verified", compact: false },
});
export function Tag({ className, variant, compact, icon, children, ...props }) {
    return (_jsxs("span", { "data-variant": variant ?? "verified", "data-compact": compact ?? false, className: cn(tagVariants({ variant, compact }), className), ...props, children: [icon ? _jsx(Glyph, { children: icon }) : null, _jsx("span", { children: children })] }));
}
//# sourceMappingURL=tag.js.map